import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { fetchBatcherOverviewData } from "./actionCreator";

export const batchOverviewSlice = createSlice({
  name: "batchOverview",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchBatcherOverviewData.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    }); 
    builder.addCase(fetchBatcherOverviewData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.data=action?.payload?.payload?.batchList;
    });
    builder.addCase(fetchBatcherOverviewData.rejected, (state, action) => {
      state.isLoading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});

export default batchOverviewSlice.reducer;
